import classes from './Info.module.css'
import Image from '../../assets/events/tribal_image.jpg';

export default function Info() {
    return (
        <>
            <div className={classes.tribal__intro}>
                <h2>Why We Run Together?</h2>
                <p>Tribal running is a Race/Event organiser across multiple terrains from Trail to Track & Field, Cross Country to Road, and much more.
                </p>
                <p>
                  It is a community that prides itself on looking after its athletes
                  both on and off the area of competition with as much support and back up as
                 possible — in sport and in life.
                </p>
            </div>
            <div className={classes.tribal__image}>
                <img src={Image} alt="Tribal Running" />
            </div>
        </>
    )

}